import { Calendar, FileText, Gavel, Users } from "lucide-react";

interface CauseStatsProps {
  causes?: any[];
}

const CauseStats = ({ causes = [] }: CauseStatsProps) => {
  const totalCases = causes.length;
  const upcomingHearings = causes.filter(
    (cause) => cause.hearingDate && new Date(cause.hearingDate) >= new Date(),
  ).length;
  const courts = new Set(
    causes.map((cause) => cause.courtRoom?._id || cause.courtRoom || cause.bench),
  ).size;
  const caseTypes = new Set(causes.map((cause) => cause.caseType)).size;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 my-6">
      <StatCard
        title="Total Cases"
        value={totalCases}
        icon={<FileText className="h-12 w-12 text-blue-500" />}
      />
      <StatCard
        title="Upcoming Hearings"
        value={upcomingHearings}
        icon={
          <div className="h-12 w-12 bg-green-500 rounded-full flex items-center justify-center">
            <Calendar className="h-6 w-6 text-white" />
          </div>
        }
      />
      <StatCard
        title="Courts"
        value={courts}
        icon={
          <div className="h-12 w-12 bg-purple-500 rounded-full flex items-center justify-center">
            <Users className="h-6 w-6 text-white" />
          </div>
        }
      />
      <StatCard
        title="Case Types"
        value={caseTypes}
        icon={
          <div className="h-12 w-12 bg-orange-500 rounded-full flex items-center justify-center">
            <Gavel className="h-6 w-6 text-white" />
          </div>
        }
      />
    </div>
  );
};

interface StatCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
}

const StatCard = ({ title, value, icon }: StatCardProps) => (
  <div className="bg-white rounded-xl p-4 shadow-sm">
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-gray-600 text-sm font-medium">{title}</h3>
        <p className="text-3xl font-bold text-gray-900 mt-2">{value}</p>
      </div>
      {icon}
    </div>
  </div>
);

export default CauseStats;
